import { SVGS } from 'app/constants/SVGS';
import { TOOLTIPS } from 'app/constants/TOOLTIPS';
import { AppInjector } from 'app/services/app-injector.service';
import { SdkInsightStateService } from 'app/states/sdk-insight-state.service';

export abstract class SdkInsightSectionComponent {
  public SVGS = SVGS;
  public TOOLTIPS = TOOLTIPS;

  protected _sdkInsightStateService: SdkInsightStateService;

  constructor() {
    this._sdkInsightStateService = AppInjector.injector.get(
      SdkInsightStateService
    );
  }
}
